import { Fragment, useContext } from "react";
import { UserContext } from "../hooks/UserContext";
import { Route, Routes } from "react-router-dom";
import Workbench from "../Components/Workbench/Workbench";
import Unauthorize from "../pages/unauthorize";
import { ADMIN, NONE, TECHNICIAN } from "../constants/routeConstants";
import { getCookie } from "../authfile";
import Home from "../Components/Home/Home";
import Login from "../pages/login";
import { ConfigurableScreen } from "../Components/Configurable/ConfigurableScreen";
import AuditLogs from "../Components/AuditLogs/AuditLogs";
import { InternalTracker } from "../Components/InternalTrackerScreen/InternalTracker";
import WithConditional from "../Components/hoc/WithConditional";

 
const RoutesComponent = () => {
    const {code,userRole} = useContext(UserContext);
    console.log("code is", code, userRole);

    return (
        <Fragment>
            {((code === null || code === '') && (getCookie('userInfo') === '' || getCookie('userInfo') === null)) ?
                (
                    <Routes>
                        <Route path="/" exact element={<Login />}></Route>
                        <Route path="/login" element={<Login />}></Route>
                        <Route path="*" element={<Login />}></Route>
                    </Routes>
                ) :
                (
                    <Fragment>
                    <WithConditional when={userRole === ADMIN || userRole === TECHNICIAN}>
                        <WithConditional when={userRole === ADMIN}>
                        <Routes>
                                <Route exact path="/" element={<Home />} />
                                <Route exact path="/workbench" element={<Workbench />} />
                                <Route exact path="/configurable" element={<ConfigurableScreen />} />
                                <Route exact path="/auditLogs" element={<AuditLogs />} />
                                <Route exact path="/internalTracker" element={<InternalTracker />} />
                            </Routes>
                        </WithConditional>
                        <WithConditional when={userRole === TECHNICIAN}>
                        <Routes>
                                <Route exact path="/" element={<Workbench />} />
                                <Route exact path="/home" element={<Home />} />
                                <Route exact path="/workbench" element={<Workbench />} />
                                {/* <Route exact path="/configurable" element={<ConfigurableScreen />} /> */}
                            </Routes>
                        </WithConditional>
                    </WithConditional>
                    <WithConditional when={userRole === NONE}>
                    <Routes>
                            <Route exact path="*" element={<Unauthorize />} />
                        </Routes>
                    </WithConditional>
                    </Fragment>
                )
            }
        </Fragment>
    );
}

export default RoutesComponent;